module.exports = {
  apiKey: 'AIzaSyDU-KvcMpMBkWGhjVZ6nTMYTx83Q7U4dsA',
  authDomain: 'niche-crm-deiner-alten.firebaseapp.com',
  projectId: 'niche-crm-deiner-alten',
  storageBucket: 'niche-crm-deiner-alten.appspot.com',
  messagingSenderId: '856806851165',
  appId: '1:856806851165:web:a0b60841f34d89a72343b4',
}
